export default "__VITE_PUBLIC_ASSET__8eaeea5b__"